
import { defineComponent, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { asideMenuIcons, isProduction } from "@/core/helpers/config";
import MainMenuConfig from "@/core/config/MainMenuConfig";
import { I18nUtils } from "@/sea/utils/I18nUtils";

export default defineComponent({
  name: "kt-menu",
  components: {},
  setup() {
    const route = useRoute();
    const scrollElRef = ref<null | HTMLElement>(null);

    onMounted(() => {
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const hasActiveChildren = (match) => {
      return route.path.indexOf(match) !== -1;
    };

    return {
      isProduction,
      hasActiveChildren,
      MainMenuConfig,
      asideMenuIcons,
      I18nUtils,
    };
  },
});
